<template>
    <v-dialog max-width="unset" v-model="inDialog">
      <v-card>
        <v-form ref="viewPresentForm">
          <div class="headline dialog-header">
            <v-toolbar color="primary" dark>
              <v-toolbar-title style="padding-left: 10px">{{
                  $t(formCreateName)
                }}</v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="onCancel"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs4></v-flex>
              <v-flex xs4>
                <div>Tên vật tư: {{mtData != undefined ? mtData.materialName: ""}}</div>
                <div>Kho: {{warehouseCode}}</div>
                <div>Từ ngày: {{fromDate | formatDate}}</div>
                <div>Đến ngày: {{toDate | formatDate}}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th :rowspan="1">Ngày chứng từ</th>
                  <th :rowspan="1">Mã chứng từ in</th>
                  <th :rowspan="1">Số chứng từ</th>
                  <th :rowspan="1">Tên đối tượng</th>
                  <th :rowspan="1">Nội dung</th>
                  <th :rowspan="1">Mã kho</th>
                  <th :rowspan="1">Số lượng nhập</th>
                  <th :rowspan="1">Đơn giá</th>
                  <th :rowspan="1">Thành tiền</th>
                  <th :rowspan="1">Số lượng xuất</th>
                  <th :rowspan="1">Đơn giá</th>
                  <th :rowspan="1">Thành tiền</th>
                </tr>
                <template v-for="item in lstImportExport">
                  <tr>
                    <td>
                      {{item.date| formatDate}}
                    </td>
                    <td>
                      <template v-if="item.type=='import'">
                        PNK
                      </template>
                      <template v-else>
                        PXK
                      </template>
                    </td>
                    <td>
                      <template v-if="item.type=='import'">
                        {{getNumber(item.requestNumber)}}
                      </template>
                      <template v-else>
                        {{getNumber(item.requestNumber) + '-' + item.cropCode}}
                      </template>
                    </td>
                    <td>
                      {{item.materialName}}
                    </td>
                    <td>
                      {{item.content}}
                    </td>
                    <td>
                      {{item.warehouseCode}}
                    </td>
                    <td>
                      <template v-if="item.type=='import'">
                        {{item.quantityImport | currency}}
                      </template>

                    </td>
                    <td>
                      <template v-if="item.type=='import'">
                        {{item.priceImport | currency}}
                      </template>
                    </td>
                    <td>
                      <template v-if="item.type=='import'">
                        {{item.amountImport | currency}}
                      </template>
                    </td>
                    <td>
                      <template v-if="item.type=='export'">
                        {{item.quantityExport | currency}}
                      </template>

                    </td>
                    <td>
                      <template v-if="item.type=='export'">
                        {{item.priceExport | currency}}
                      </template>

                    </td>
                    <td>
                      <template v-if="item.type=='export'">
                        {{item.amountExport | currency}}
                      </template>

                    </td>
                  </tr>
                </template>
              </table>

            </v-flex>

          </v-layout>
          <v-card-text>
            <v-layout>
              <v-flex xs8 md8>
              </v-flex>
              <v-flex xs4 md4>
                <table class="lstTable">
                  <tr>
                    <th :rowspan="1"></th>
                    <th :rowspan="1">Số lượng</th>
                    <th :rowspan="1">Thành tiền</th>
                  </tr>
                  <tr>
                    <td>Tồn đầu kỳ</td>
                    <td><template v-if="mtData">{{mtData.openingBalanceQuantity| currency}}</template></td>
                    <td><template v-if="mtData">{{mtData.openingBalanceMoney| currency}}</template></td>
                  </tr>
                  <tr>
                    <td>Nhập trong kỳ</td>
                    <td><template v-if="mtData">{{mtData.import | currency}}</template></td>
                    <td><template v-if="mtData">{{mtData.importMoney| currency}}</template></td>
                  </tr>
                  <tr>
                    <td>Xuất trong kỳ</td>
                    <td><template v-if="mtData">{{mtData.export| currency}}</template></td>
                    <td><template v-if="mtData">{{mtData.exportMoney| currency}}</template></td>
                  </tr>
                  <tr>
                    <td>Tồn cuối kỳ</td>
                    <td><template v-if="mtData">{{mtData.endingBalanceQuantity| currency}}</template></td>
                    <td><template v-if="mtData">{{ mtData.endingBalanceMoney| currency}}</template></td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-card-text>


        </v-form>
      </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
export default {
    name: "import-export-detail",
    components: { axios },
    props: {
        cDialog: {
            type: Boolean,
            default: false,
        },
        formCreateName: {
            type: String,
            default: 'Chi tiết Nhập xuất',
        },
        materialId: {
          type: [Number, String],
          default: ""
        },
        groupData:{
          type: Array,
          default: () => []
        },
        mtData:{
          type: Object,
          default: () => {}
        },
        fromDate:{
          type: [String,Number,Date]
        },
        toDate:{
          type: [String,Number,Date]
        },
        warehouseCode:{
          type: String,
        },
        lstImportExport:{
          type: Array,
          default: () => []
        },
    },
    data: () => {
        return {
            inDialog: false,
        };
    },
    watch: {
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeDialog", "");
            }
        },

    },
    methods: {
        onCancel: function () {
            this.$emit("closeDialog", "");
        },
        getNumber(pnk){
          if(pnk == undefined){
            return ""
          } else{
            return pnk.replace("ĐNX/", "").replace("PNK/", "")
          }
        }

    },
    created() {},
};
</script>
